import { createSlice } from "@reduxjs/toolkit";
import {
    defaultMenuType,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
} from '../../constants/defaultValues';

const initialState = {
    menuItems: [{ id: '', to: '#' }],
    containerClassnames: defaultMenuType,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount: 0,
    selectedMenuHasSubItems: defaultMenuType === 'menu-default',
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        menuSetItems(state, action) {
            state.menuItems = action.payload;
        },
        menuChangeHasSubItemsStatus(state, action) {
            state.selectedMenuHasSubItems = action.payload
        },
        menuSetClassnames(state, action) {
            let { selectedMenuHasSubItems, containerClassnames, clickIndex } = action.payload;
            const currentClasses = containerClassnames
                ? containerClassnames.split(' ').filter((x) => x !== '')
                : '';
            let nextClasses = '';
            if (!selectedMenuHasSubItems) {
                if (
                    currentClasses.includes('menu-default') &&
                    (clickIndex % 4 === 0 || clickIndex % 4 === 3)
                ) {
                    clickIndex = 1;
                }
                if (currentClasses.includes('menu-sub-hidden') && clickIndex % 4 === 2) {
                    clickIndex = 0;
                }
                if (
                    currentClasses.includes('menu-hidden') &&
                    (clickIndex % 4 === 2 || clickIndex % 4 === 3)
                ) {
                    clickIndex = 0;
                }
            }

            if (clickIndex % 4 === 0) {
                if (
                    currentClasses.includes('menu-default') &&
                    currentClasses.includes('menu-sub-hidden')
                ) {
                    nextClasses = 'menu-default menu-sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden';
                }
                clickIndex = 0;
            } else if (clickIndex % 4 === 1) {
                if (
                    currentClasses.includes('menu-default') &&
                    currentClasses.includes('menu-sub-hidden')
                ) {
                    nextClasses = 'menu-default menu-sub-hidden main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary';
                }
            } else if (clickIndex % 4 === 2) {
                if (
                    currentClasses.includes('menu-default') &&
                    currentClasses.includes('menu-sub-hidden')
                ) {
                    nextClasses = 'menu-default menu-sub-hidden sub-hidden';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default main-hidden sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden sub-hidden';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary sub-show-temporary';
                }
            } else if (clickIndex % 4 === 3) {
                if (
                    currentClasses.includes('menu-default') &&
                    currentClasses.includes('menu-sub-hidden')
                ) {
                    nextClasses = 'menu-default menu-sub-hidden sub-show-temporary';
                } else if (currentClasses.includes('menu-default')) {
                    nextClasses = 'menu-default sub-hidden';
                } else if (currentClasses.includes('menu-sub-hidden')) {
                    nextClasses = 'menu-sub-hidden sub-show-temporary';
                } else if (currentClasses.includes('menu-hidden')) {
                    nextClasses = 'menu-hidden main-show-temporary';
                }
            }
            if (currentClasses.includes('menu-mobile')) {
                nextClasses += ' menu-mobile';
            }
            state.containerClassnames = nextClasses ? nextClasses : containerClassnames;
            state.menuClickCount = clickIndex ?? 0;
        },
        menuClickMobileMenu(state) {
            const currentClasses = state.containerClassnames
                ? state.containerClassnames
                    .split(' ')
                    .filter((x) => x !== '' && x !== 'sub-show-temporary')
                : '';
            if (currentClasses.includes('main-show-temporary')) {
                state.containerClassnames = currentClasses
                    .filter((x) => x !== 'main-show-temporary')
                    .join(' ');
            } else {
                state.containerClassnames = `${currentClasses.join(' ')} main-show-temporary`;
            }
            state.menuClickCount = 0
        },
        menuContainerAddClassname(state, action) {
            const { payload: classname } = action;
            state.containerClassnames =
                !state.containerClassnames.indexOf(classname) > -1
                    ? `${state.containerClassnames} ${classname}`
                    : state.containerClassnames;
        },
        menuChangeDefaultClassnames(state, action) {
            state.containerClassnames = action.payload
        },
    },
});


export default menuSlice.reducer;

export const {
    menuSetItems,
    menuChangeHasSubItemsStatus,
    menuSetClassnames,
    menuClickMobileMenu,
    menuContainerAddClassname,
    menuChangeDefaultClassnames
} = menuSlice.actions;


